<template>
  <label class="weui-cell weui-check__label" :for="id">
    <div class="weui-cell__bd">
      <p>{{ text }}</p>
    </div>
    <div class="weui-cell__ft">
      <input type="radio" class="weui-check" :id="id" :name="name" :value="value" :checked="checked" @change="fireChange">
      <span class="weui-icon-checked" />
    </div>
  </label>
</template>

<script>
import mixinUniqid from '@/mixins/uniqid';

export default {
    props: {
        name: {
            type: String,
            default: '',
        },
        value: {
            type: [Boolean, String, Number, Object],
            required: true,
        },
        text: {
            type: String,
            default: null,
        },
        checked: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            id: this.uniqid(),
        };
    },
    methods: {
        fireChange() {
            this.$emit('input', this.value);
            this.$emit('change', this.value);
        },
    },
    mixins: [
        mixinUniqid,
    ],
};
</script>



// WEBPACK FOOTER //
// src/components/weui/radio-group/RadioBox.vue